"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Eingabe-Element.
 *
 * @class
 * @abstract
 * @extents gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} [options.id] HTML-ID des Eingabefeldes
 * @param {string} [options.name] Name des Eingabefeldes
 * @param {*} [options.default=''] Default-Wert
 * @param {string} [options.label] Bezeichnung des Eingabefeldes
 * @param {string} [options.tooltip] Tooltip des Eingabefeldes
 * @param {string} [options.className=''] CSS-Klasse(n) für den Container
 * @param {string} [options.inputClassName=''] CSS-Klasse(n) für das Input-Element
 */
gc.gis.widget.GCInput = function(options)
{
	gc.gis.widget.GCWidget.call(this, options);

	this._inputElement      = null;

	this.label              = options.label || '';
	this.name               = options.name;
	this.defaultValue       = options.default;
	this.tooltip            = options.tooltip;
	this.inputClassName     = options.inputClassName || '';
};
gc.gis.widget.GCInput.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * Liefert das Element, für die Nutzereingabe. Das gesamte Element, welches durch getElement() repräsentiert wird
 * umfasst als Container mehrere HTML-Elemente.
 *
 * @return {jQuery}
 */
gc.gis.widget.GCInput.prototype.getElementInput = function()
{
	return this._inputElement;
};

/**
 * Liefert den aktuellen Wert des Eingabe-Elements.
 *
 * @public
 * @abstract
 * @method
 *
 * @return {*} Wert des Eingabe-Elements
 */
gc.gis.widget.GCInput.prototype.getValue = gc.gis.abstractMethod;

/**
 * Liefert das eigentliche InputElement (ohne Label und Container etc.).
 *
 * @public
 * @abstract
 * @method
 *
 * @return {jQuery} Input-Element
 */
gc.gis.widget.GCInput.prototype._renderInput = gc.gis.abstractMethod;

/**
 * @inheritDoc
 */
gc.gis.widget.GCInput.prototype._render = function()
{
	if (!this.element)
	{
		this._inputElement = this._renderInput();
		this._setupCommonAttributes(this._inputElement);
		this.element = this._renderLabelFor(this._inputElement);
	}

	return this.element;
};

/**
 * Setzt Universalattribute am übergebenen Element.
 *
 * @protected
 * @method
 *
 * @param {jQuery} input_element
 *      jQuery-Element, dem die Attribute angehangen werden.
 */
gc.gis.widget.GCInput.prototype._setupCommonAttributes = function(input_element)
{
	if (this.id)
	{
		input_element.attr('id', this.id);
	}

	if (this.name)
	{
		input_element.attr('name', this.name);
	}

	if (this.tooltip)
	{
		input_element.attr('title', this.tooltip);
	}
};

/**
 * Rendert ein <code>&lt;label&gt;</code>-Element und schließt das
 * übergebene Control darin ein.
 *
 * @public
 * @method
 *
 * @param {jQuery} input_element
 *      Mit <code>&lt;label&gt;</code> zu umschließendes jQuery-Element
 *
 * @param {Object<string,*>} [config]
 *      Konfiguration des Labels.
 *
 * @param {jQuery|string} [config.prefix]
 *      Optionale[s/r] Element/String, d[as/er] vor
 *      <code>element_control</code> (in einem <code>&lt;span&gt;</code>
 *      gewrappt) zum Label hinzugefügt wird.
 *
 * @param {jQuery|string} [config.suffix]
 *      Optionale[s/r] Element/String, d[as/er] nach
 *      <code>element_control</code> (in einem <code>&lt;span&gt;</code>
 *      gewrappt) zum Label hinzugefügt wird.
 *
 * @param {boolean} [opt_after=false]
 *      Optionales Flag, ob der Labeltext nach <code>element_control</code>
 *      zum <code>&lt;label&gt;</code> hinzugefügt wird. Geeignet für z.B.
 *      Checkboxen.
 *
 * @return {jQuery} jQuery-Container-Element
 */
gc.gis.widget.GCInput.prototype._renderLabelFor = function(input_element, config, opt_after)
{
	config = config || {};

	var element_label = jQuery('<span>', {
		'class': 'control-label',
		html: this.label
	});

	var element = jQuery('<label>');
	var element_container;

	if(!config.prefix && !config.suffix)
	{
		element_container = element;
		element_container.append(element_label);
	}
	else
	{
		element_container = jQuery('<span>', {
			'class': 'input-group'
		});

		element.append(element_label);
		element.append(element_container);
	}

	if(!opt_after)
	{
		element_container.append(' ');
		element_container.append(input_element);
	}
	else
	{
		element_container.prepend(' ');
		element_container.prepend(input_element);
	}

	if(config.prefix)
	{
		element_container.prepend(' ');
		element_container.prepend( jQuery('<span>', {
			'class': 'input-group-addon',
			html: config.prefix
		}) );
	}
	if(config.suffix)
	{
		element_container.append(' ');
		element_container.append( jQuery('<span>', {
			'class': 'input-group-addon',
			html: config.suffix
		}) );
	}

	if(this.id)
	{
		element.attr('for', this.id);
	}

	return jQuery('<div>', {
		'class': 'form-group',
		html: element
	});
};